import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EventGraphQL from '@graphql/event.queries';
import { Event } from '@models/event.model';

interface CreateEventInput {
  name: string;
  eventType: string;
  otherEventType?: string | null;
  eventTime: Date | string;
  incidentType?: string | null;
  addedIncidentType?: string | null;
  inspectionType?: string | null;
  permit?: string | null;
  delay?: number | null;
  delayType?: string | null;
  notes?: string | null;
  precedentTaskId?: string[];
  projectId: string;
}

interface UseCreateEventReturn {
  createEvent: (input: CreateEventInput) => Promise<Event | null>;
  loading: boolean;
  error: string | null;
}

export const useCreateEvent = (): UseCreateEventReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createEvent = useCallback(
    async (input: CreateEventInput): Promise<Event | null> => {
      setLoading(true);
      setError(null);

      try {
        const data: any = await graphQlClient.request(
          EventGraphQL.mutations.createEvent,
          { event: input },
        );

        return data?.createEvent || null;
      } catch (err: any) {
        const errorMessage =
          err?.response?.errors?.[0]?.message || 'Failed to create event';
        setError(errorMessage);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createEvent,
    loading,
    error,
  };
};
